import { FRAGMENT_LISTING_DISCOUNT } from '@marketplace/graphql/config/shared-fragments.js'
import gql from 'graphql-tag'

export const FRAGMENT_LISTING_PRODUCT_CARD = gql`
    ${FRAGMENT_LISTING_DISCOUNT}
    fragment FragmentListingProductCard on Listing {
        ...FragmentGlobalDiscount
        availableAt
        brand
        caseQuantity
        minimumOrderQuantity
        databaseId
        id
        inStock
        isBestseller
        isFavorite
        isNew
        isTopPick
        catalogDiscountPercentage
        msrpMax
        msrpMin
        priceMax
        priceMin
        title
        url
        images(first: 3) {
            totalCount
            edges {
                node {
                    id
                    x1: transformedUrl(width: 260, height: 260)
                    x2: transformedUrl(width: 480, height: 480)
                }
            }
        }
        mainImageDescription
        isOutlet
        qualifiesForFreeShippingEvent
        storefront {
            id
            slug
            name
            campaignDiscount {
                id
                campaign
                percentage
                createdAt
                orderchampContributionPercentage
            }
            discountPercentage
            needsRetailerApproval
            retailerApprovalStatus
            databaseId
            isLowMinimumsParticipant
        }
    }
`
